import { render, staticRenderFns } from "./buildQuestion.vue?vue&type=template&id=5e37147d&"
import script from "./buildQuestion.vue?vue&type=script&lang=js&"
export * from "./buildQuestion.vue?vue&type=script&lang=js&"
import style0 from "./buildQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports